'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-curve-fitting/~/ml-matrix/src/index.js
 ** module id = 12
 ** module chunks = 0
 **/